module.exports = "/_next/static/images/arrow_up-e4a3acda2e90014f5a127940c73ae972.svg";